import { flowUtils } from '@atlassian/mpac-utils';
export function foldMarketplaceProduct(marketplaceProduct) {
  return function (jira, confluence) {
    switch (marketplaceProduct) {
      case 'jira':
        return jira();
      case 'confluence':
        return confluence();
      default:
        throw flowUtils.unexpectedCase(marketplaceProduct);
    }
  };
}